import React from "react";
import { Link } from "react-router";
import Dialog from "rc-dialog";
import axios from "axios";
import classNames from "classnames";

import Pagination from "../../components/Pagination";
import Filter from "../../components/Filter";
import FormErrorHandler from "../../components/FormErrorHandler";
import { getDeep } from "../../functions.js";

export default class InstructorsOverview extends React.Component {
    constructor(props) {
        super(props);

        let defaultFilters = {};

        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        this.state = {
            resultRows: false,
            authorities: [],
            count: 0,
            limit: 0,
            offset: 0,
            nibhv_number: "",
            loading: false,
            searched: false,
            searchResults: [],
            searchResultsProCRM: [],
            addInstructorVisible: false,
            addInstructorError: {},
            activeFilters: defaultFilters
        };
    }

    cancelAxiosRequest = () => {
        this.cancelSource.cancel();

        this.setState({
            resultRows: false,
            count: 0,
            limit: 0,
            offset: 0
        });
    };

    updateElementState = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            activeTrainerError: false
        });
    };

    handleFilter = (name, value) => {
        let activeFilters = this.state.activeFilters;
        activeFilters[name] = value;

        this.setState({
            activeFilters,
            offset: 0
        });
        this.getResults(this.state.offset);
    };

    getResults = (offset) => {
        this.cancelAxiosRequest();
        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        axios
            .get("/v1/instructors/", {
                params: {
                    offset: offset,
                    ...this.state.activeFilters
                },
                cancelToken: this.cancelSource.token
            })
            .then((response) => {
                this.setState({
                    resultRows: response.data.results,
                    count: response.data.count,
                    limit: response.data.limit,
                    offset: response.data.offset
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    searchInstructor = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
            searchResults: [],
            searchResultsProCRM: []
        });

        axios
            .get(
                `/v1/users/?nibhv_number=${this.state.nibhv_number}&pagination=false&fields=uuid,nibhv_number,first_name,last_name,last_name_prefix,date_of_birth,is_instructor`
            )
            .then((response) => {
                let searchResults = response.data;

                this.setState({
                    searched: true,
                    loading: false,
                    searchResults
                });
            })
            .catch((error) => {
                // This NIBHV number might be faulty, search the old CRM
            })
            .then(() => {
                this.searchInstructorProCRM();
            });
    };

    searchInstructorProCRM = () => {
        this.setState({
            loading: true
        });
        axios
            .get(`/v1/procrm/instructors/?nibhvnr=${this.state.nibhv_number}`)
            .then((response) => {
                let searchResultsProCRM = response.data;

                this.setState({
                    searched: true,
                    loading: false,
                    searchResultsProCRM
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    updateUserToInstructor = (e, uuid) => {
        e.preventDefault();
        // We have a user UUID to patch, get the company_authorizations from the current user
        // We copy these and add them to the newly promoted user to make sure he has the same
        // company_authorizations added and is coupled to the same companies.
        axios
            .get("/v1/users/self/")
            .then((response) => {
                let companyAuth = response.data.company_authorizations;

                let requests = [];
                companyAuth.forEach((auth) => {
                    requests.push(
                        axios.post(`/v1/trainers/${auth.company}/user_authorizations/`, {
                            user: uuid,
                            can_change_companyuserauthorization: false
                        })
                    );
                });

                axios
                    .all(requests)
                    .then((results) => {
                        this.setState({
                            searched: false,
                            nibhv_number: "",
                            addInstructorVisible: false,
                            addInstructorError: {},
                            searchResults: []
                        });

                        this.getResults();
                    })
                    .catch((error) => {
                        this.setState({
                            addInstructorError: error.response.data
                        });
                        console.log(error);
                    });
            })
            .catch((error) => {
                this.setState({
                    addInstructorError: error.response.data
                });
                console.log(error);
            });
    };

    updateUserToInstructorFromProCRM = (e, pro_crm_relation_id) => {
        e.preventDefault();
        // Create instructor from the old system
        axios
            .post("/v1/procrm/instructors/", {
                nibhvnr: pro_crm_relation_id
            })
            .then((response) => {
                let uuid = response.data[0].uuid;
                this.updateUserToInstructor(e, uuid);

                this.getResults();
            })
            .catch((error) => {
                console.log(error);
            });
    };

    toggleItem = (e, itemID, itemName, currentStatus) => {
        let question = "Weet je zeker dat je deze instructeur wilt activeren?";
        let description = `De instructeur '${itemName}' is succesvol geactiveerd`;

        if (currentStatus) {
            // Current status is true, so we toggle to false
            question =
                "Wanneer de volgende gebruiker wordt gedeactiveerd als instructuur zal hij worden verwijderd van alle toekomstige toetsmomenten. Wilt u de rol verwijderen?";
            description = `De instructeur '${itemName}' is succesvol gedeactiveerd`;
        }

        if (confirm(question)) {
            axios
                .patch("/v1/instructors/" + itemID + "/", {
                    is_active: !currentStatus
                })
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: description,
                        link: `/instructors/edit/${itemID}`
                    });
                    this.props.router.push("/instructors");
                    this.getResults(0);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    componentDidMount() {
        this.getResults(0);

        // Get the available authorities
        axios
            .get("/v1/authorities/?fields=code,name&pagination=false")
            .then((response) => {
                this.setState({
                    authorities: response.data
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        let tableRows = [];

        if (this.state.resultRows !== false) {
            let resultRows = this.state.resultRows;

            if (resultRows.length == 0) {
                tableRows.push(
                    <tr key="0">
                        <td colSpan="10">Met deze filters konden geen resultaten worden gevonden</td>
                    </tr>
                );
            }
            
            const canChangeInstructor = getDeep(this.props.permissions, "user", "change-instructor");

            resultRows.forEach((result) => {
                let classnames = classNames({ inactive: !result.is_active });

                let activateItem = (
                    <i
                        className="fa fa-toggle-on"
                        title="Deactiveren"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.toggleItem(e, result.uuid, result.first_name + " " + result.last_name, result.is_active);
                        }}
                    ></i>
                );
                if (!result.is_active) {
                    activateItem = (
                        <i
                            className="fa fa-toggle-off"
                            title="Activeren"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.toggleItem(e, result.uuid, result.first_name + " " + result.last_name, result.is_active);
                            }}
                        ></i>
                    );
                }

                let auth = result.authorities.map((auth) => {
                    let authority = this.state.authorities.find((authority) => authority.code == auth);
                    if (authority !== undefined) {
                        return authority.name;
                    }
                    return false;
                });

                tableRows.push(
                    <tr
                        key={result.uuid}
                        onClick={() => {
                            canChangeInstructor ? this.props.router.push("/instructors/edit/" + result.uuid) : false;
                        }}
                        className={classnames}
                    >
                        <td>
                            {result.full_name}
                            <br />
                            <span className="lighter">{result.nibhv_number}</span>
                        </td>
                        <td>{auth.length ? auth.join(", ") : "-"}</td>
                        {canChangeInstructor ? <td>{activateItem}</td> : false}
                    </tr>
                );
            });
        } else {
            tableRows.push(
                <tr key="1">
                    <td colSpan="10">Instructeurs ophalen...</td>
                </tr>
            );
        }

        let filterAuthorities = [];
        this.state.authorities.forEach((auth) => {
            filterAuthorities.push({ value: auth.code, name: auth.name });
        });

        let foundInstructorsBlock = "";
        if (this.state.searched) {
            if (this.state.searchResults.length > 0) {
                let foundInstructor = this.state.searchResults[0];

                if (foundInstructor.is_instructor) {
                    foundInstructorsBlock = (
                        <div className="row mt-2 mb-2">
                            <div className="col-12">
                                <strong>{foundInstructor.formal_name}</strong>
                                <br />
                                {foundInstructor.email}
                                <br />
                                <br />
                                <button className="btn btn-secondary" onClick={(e) => this.updateUserToInstructor(e, foundInstructor.uuid)}>
                                    Toevoegen als instructeur
                                </button>
                            </div>
                        </div>
                    );
                } else {
                    // The found user is not an instructor, show a notification of this fact
                    foundInstructorsBlock = (
                        <div className="row mt-2 mb-2">
                            <div className="col-12">
                                <p>
                                    <strong>Let op:</strong> er werd wel een gebruiker gevonden onder dit NIBHV-nummer, deze staat echter niet bekend als instructeur.
                                </p>
                                <p>Neem contact op met NIBHV om te controleren of deze gebruiker op de juiste manier en met de juiste rechten in het systeem staat.</p>
                            </div>
                        </div>
                    );
                }
            } else if (this.state.searchResultsProCRM.length > 0) {
                let foundInstructor = this.state.searchResultsProCRM[0];

                let foundUser = false;
                // If we already have a current user
                if (foundInstructor?.user) {
                    foundUser = (
                        <div>
                            <em>Deze is gekoppeld aan:</em>
                            <br />
                            <strong>{foundInstructor?.user?.formal_name}</strong>
                            <br />
                            <span className="lighter">
                                NIBHV-nummer: {foundInstructor?.user?.nibhv_number}
                                <br />
                                {foundInstructor?.user?.email}
                                <br />
                                Rol: {foundInstructor?.user?.is_instructor ? "Instructeur" : "Cursist"}
                            </span>
                        </div>
                    );
                }

                foundInstructorsBlock = (
                    <div className="row mt-2 mb-2">
                        <div className="col-6 mb-2">
                            <em>Gevonden in ProCRM:</em>
                            <br />
                            <strong>{`${foundInstructor.initials || foundInstructor.first_name} ${foundInstructor.last_name_prefix || ""} ${foundInstructor.last_name}${
                                foundInstructor.maiden_name ? "-" + foundInstructor.maiden_name : ""
                            }`}</strong>
                            <br />
                            <span className="lighter">
                                Relatienummer: {foundInstructor.pro_crm_relation_id}
                                <br />
                                {foundInstructor.email}
                                <br />
                                Rol: Instructeur
                            </span>
                        </div>
                        <div className="col-6 mb-2">{foundUser}</div>
                        {!foundUser || (foundInstructor?.user && foundInstructor?.user?.is_instructor) ? (
                            <div className="col-12">
                                <button className="btn btn-secondary" onClick={(e) => this.updateUserToInstructorFromProCRM(e, foundInstructor.pro_crm_relation_id)}>
                                    Toevoegen als instructeur
                                </button>
                            </div>
                        ) : (
                            <div className="col-12">
                                Er is al een gebruiker aanwezig met hetzelfde e-mailadres en een andere rol.
                                <br />
                                Neem contact op met NIBHV voor een passende oplossing.
                            </div>
                        )}
                    </div>
                );
            } else {
                foundInstructorsBlock = (
                    <div className="row mt-2 mb-2">
                        <div className="col-12">Helaas, er werden geen instructeurs gevonden met dit NIBHV nummer.</div>
                    </div>
                );
            }
        }

        return (
            <div>
                <div className="section-top">
                    <h1>Instructeurs</h1>

                    <div className="section-buttons">
                        {getDeep(this.props.permissions, "user", "change-instructor") ? (
                            <Link to="/instructors/new" className="btn btn-primary">
                                Instructeur aanmaken
                            </Link>
                        ) : (
                            ""
                        )}
                        {getDeep(this.props.permissions, "user", "create") && !getDeep(this.props.permissions, "user", "change-instructor") ? (
                            <span
                                className="btn btn-primary"
                                onClick={() =>
                                    this.setState({ addInstructorVisible: true, nibhv_number: "", searched: false, searchResults: [], addInstructorError: {} })
                                }
                            >
                                Instructeur toevoegen met NIBHV-nummer
                            </span>
                        ) : (
                            ""
                        )}
                    </div>
                </div>

                <div className="row">
                    <div className="col-3 filters">
                        <Filter
                            title="Bevoegdheid"
                            type="multiselect"
                            filterName="authorities__code"
                            filters={filterAuthorities}
                            handleFilter={(name, value) => this.handleFilter(name, value)}
                            activeFilters={this.state.activeFilters}
                        />
                    </div>
                    <div className="col-9">
                        <div className="filter-text-wrapper">
                            <Filter
                                title="Zoeken"
                                type="text"
                                filterName="search"
                                filters={[]}
                                handleFilter={(name, value) => this.handleFilter(name, value)}
                                activeFilters={this.state.activeFilters}
                            />
                            <i className="fa fa-search" />
                        </div>

                        <table className="table table-hover table-clickable">
                            <thead>
                                <tr>
                                    <th>Naam</th>
                                    <th width="60%">Bevoegdheden</th>
                                    {getDeep(this.props.permissions, "user", "change-instructor") ? <th>Actief</th> : false}
                                </tr>
                            </thead>
                            <tbody>{tableRows}</tbody>
                        </table>

                        <Pagination count={this.state.count} limit={this.state.limit} offset={this.state.offset} pageSwitch={(i) => this.getResults(i)} />
                    </div>
                </div>

                <Dialog
                    title="Instructeur toevoegen op basis van NIBHV-nummer"
                    onClose={() => this.setState({ addInstructorVisible: false, nibhv_number: "" })}
                    visible={this.state.addInstructorVisible}
                    width={700}
                    footer={[
                        <button type="button" className="btn btn-primary" key="no" onClick={this.searchInstructor}>
                            Zoeken
                        </button>
                    ]}
                >
                    <p>
                        Er kunnen alleen instructeurs met een NIBHV-instructeursnummer toegevoegd worden.
                        <br />
                        Nog geen NIBHV-instructeursnummer? Stuur een e-mail naar <a href="mailto:advies@nibhv.nl">advies@nibhv.nl</a>.
                    </p>
                    <form method="post" onSubmit={this.searchInstructor}>
                        <div className="row mt-2 mb-2">
                            <div className="col-12">
                                <label>NIBHV-nummer *</label>
                                <input
                                    type="text"
                                    name="nibhv_number"
                                    className="form-control"
                                    required={true}
                                    value={this.state.nibhv_number}
                                    onChange={this.updateElementState}
                                    maxLength="50"
                                />
                            </div>
                        </div>
                        {foundInstructorsBlock}
                        <FormErrorHandler fieldName="all" errorObject={this.state.addInstructorError} />
                        {this.state.loading ? (
                            <div>
                                <i className="fa fa-spin fa-spinner"></i> Ophalen van gegevens...
                            </div>
                        ) : (
                            false
                        )}
                    </form>
                </Dialog>
            </div>
        );
    }
}
